import { createActions } from 'redux-actions';

export const { updateGuestServicesRequests } = createActions('UPDATE_GUEST_SERVICES_REQUESTS');
